import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from "prop-types";

import './blur.css'
class Blur extends Component {
  render () {
    let blurClass = this.props.isOpen ? 'blurred' : null

    return (
      <div className={blurClass}>
        {this.props.children}
      </div>
    )
  }
}

Blur.propTypes = {
  currentItem: PropTypes.number,
  scroll: PropTypes.bool,
  isOpen: PropTypes.bool
}

const mapStateToProps = state => {
  const {menu} = state
  return {
    ...menu
  }
}

export default connect(mapStateToProps)(Blur)


// WEBPACK FOOTER //
// ./src/components/blur/blur.js